import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const marquee = (): void => {
  const settings = {
    duration: 50, // Loop duration
  };
  const scrollers = document.querySelectorAll('.c-scroller');
  scrollers.forEach((scroller) => {
    const slideWidth = (scroller.querySelector('.c-scroller__item') as HTMLElement).clientWidth;
    const scrollSwiper = new Swiper(scroller.querySelector('.swiper') as HTMLElement, {
      loop: true,
      speed: (1000 * slideWidth) / settings.duration, // Loop duration
      allowTouchMove: false, // Disable swipe
      autoplay: {
        delay: 0, // Continuous loop
      },
      slidesPerView: 'auto',
      spaceBetween: 0,
    });
  });
};
